import React  from 'react'
import Avatar from 'components/Avatar'
import { Row, Col , Empty,Pagination } from 'antd'
import Button from 'components/Button'
import {
  Name,
  Address,
  NameAdd,
  FullTable,
  SlRow,
  SlCol,
  SlCol1,
  ContentCenterDiv,
  LeftAlignCol,
  Name1
} from 'modules/Applied_Roles/Style/style'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setViewRoleData } from 'modules/Applied_Roles/actions'
import moment from 'moment'
const SingleListed = ({page, dataList, onPageChange }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const onChange = key => {
    onPageChange(key)
  }

  const viewRoles  = (event, param) => {
 
    dispatch(setViewRoleData(param))
 
    navigate(`/roles/viewrole/${param.role.corporateId}/${param.role.id}`)
  }
  const CheckIcon = logo => {
    if (logo === null) {
      return (
        <Avatar 
          size={42}
          src={<ApartmentIcon />}
          boxShadow={true}
          padding={'3px'}
        />
      )
    } else {
      return (
        <Avatar size={42} src={logo} />
      )
    }
  }

  const HyphenCheck = data => {
    if(data != '' &&  data != undefined){
      return data?.toLowerCase()
    }
    else
    {
      return '-'
    }
  }
  const TimeCheck = data => {
    if(data != null && data != undefined){
      return moment(data)?.format('DD/MM/YYYY')
    }
    else{
      return 'Not Yet Scheduled'
    }
  }

  const getDriveMode = driveMode => {
    if(driveMode != '' &&  driveMode != undefined){
    return driveMode?.toLowerCase()?.replace('_', ' ')
    }
    else
    {
      return '-'
    }
  }
  const checkTime = (start, end) => {   
    let startTime = `${Number(start.slice(0, 2)) > 12 ? 'PM' : 'AM'}`
    let endTime = `${Number(end.slice(0, 2)) > 12 ? 'PM' : 'AM'}`
    let startTimeCheck = parseInt(start.slice(0, 2)) > 13 ? `${parseInt(start.slice(0, 2)) -12} ${start.slice(3, 5)} ${startTime}`: `${parseInt(start.slice(0, 2))} ${start.slice(2, 5)} ${startTime}`
    let endTimeCheck = parseInt(end.slice(0, 2)) > 13 ? `${parseInt(end.slice(0, 2)) -12} ${end.slice(2, 5)} ${endTime}`: `${parseInt(end.slice(0, 2))} ${end.slice(2, 5)} ${endTime}`
    return startTimeCheck + ' - ' + endTimeCheck
  }
  return (
    <>
      <FullTable>
        {dataList?.list?.map((item, index) => (
            <SlRow key={index+"list"}>
              <SlCol1>
                <Row>
                  <Col>{CheckIcon(item?.role?.corporate?.logo ?? null)}</Col>
                  <LeftAlignCol>
                    <NameAdd column flexStart>
                      <Name1>{item?.role?.corporate?.name ?? item?.role?.company?.companyName}</Name1>
                      <Address>{item?.role?.tittle}</Address>
                    </NameAdd>
                  </LeftAlignCol>
                </Row>
              </SlCol1>

              <SlCol>
                <NameAdd column flexStart>
                  <Address>Drive Type</Address>
                  <Name>{getDriveMode(item?.role?.driveRoleCandidateMap?.[0]?.drive?.driveMode)}</Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Interview Stage</Address>
                  <Name>{HyphenCheck(item?.role?.driveRoleCandidateMap?.[0]?.stage)}</Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Status</Address>
                  <Name>{HyphenCheck(item?.role?.driveRoleCandidateMap?.[0]?.status)}</Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Time</Address>
                  {item?.role?.driveRoleCandidateMap?.[0]?.drive?.startDate != null ?
<>
                  <Name>{TimeCheck(item?.role?.driveRoleCandidateMap?.[0]?.drive?.startDate)}</Name>
<Name>{checkTime(item?.role?.driveRoleCandidateMap?.[0]?.drive.startTime, item?.role?.driveRoleCandidateMap?.[0]?.drive?.endTime)}</Name>
                  </>
                  :
                  <Name> Not Yet Scheduled</Name>
}
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Last Updated</Address>
                  <Name>{moment(item?.role?.updateAt)?.format('DD/MM/YYYY') }</Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <Button.Secondary onClick={event => viewRoles(event,item)} text={'View'} width={'80px'} />
              </SlCol>
            </SlRow>
        ))}
      </FullTable>
      {dataList?.count === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <ContentCenterDiv>
          <br></br>
          <Pagination
          showSizeChanger={false}
            current={page}
            total={dataList?.count}
            onChange={onChange}
            defaultCurrent={1}
          />
        </ContentCenterDiv>
      )}
    </>
  )
}
export default SingleListed
